interface WarningOctagonIconProps {
  size?: number;
}

export function WarningOctagonIcon({ size = 80 }: WarningOctagonIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" aria-hidden="true">
      <polygon
        points="26,4 54,4 76,26 76,54 54,76 26,76 4,54 4,26"
        stroke="var(--builders-color-error-200)"
        strokeWidth="3"
        fill="none"
      />
      <line
        x1="40"
        y1="24"
        x2="40"
        y2="50"
        stroke="var(--builders-color-error-200)"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="40" cy="60" r="3" fill="var(--builders-color-error-200)" />
    </svg>
  );
}
